//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiVuetify } from '@mdi/js'

export default {
  setup() {
    const messages = 0

    return {
      messages,
      icons: { mdiVuetify },
    }
  },
}
